module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_both_location@2x-b9b47a24e6194ccb802903dc33566745.webp";